"use client";

import { c as _c } from "react/compiler-runtime";
import CallbackRequestModal from "@/components/sup/callback-request-modal";
import { useAuth } from "@/hooks/use-auth";
import { useLoginDialog } from "@/hooks/use-login-dialog";
import { Phone } from "lucide-react";
import { useState } from "react";
import { PromotionalCardBase } from "../card-base";
import { PromotionalCardProps } from "../types";
export function ScheduleCallCard(t0) {
  const $ = _c(17);
  const {
    className
  } = t0;
  const [open, setOpen] = useState(false);
  const {
    isAuthenticated,
    user
  } = useAuth();
  const {
    openDialog
  } = useLoginDialog();
  let t1;
  if ($[0] !== isAuthenticated || $[1] !== openDialog) {
    t1 = e => {
      e?.preventDefault();
      e?.stopPropagation();
      if (!isAuthenticated) {
        openDialog({
          onLoginSuccess: () => setOpen(true)
        });
      } else {
        setOpen(true);
      }
    };
    $[0] = isAuthenticated;
    $[1] = openDialog;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleClick = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Phone className="w-full h-full" strokeWidth={1.5} />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== className || $[5] !== handleClick) {
    t3 = <PromotionalCardBase icon={t2} title="Talk to an Expert" description="Have questions? Schedule a free consultation with our property experts" ctaText="Request Callback" onClick={handleClick} className={className} iconColor="text-blue-600" />;
    $[4] = className;
    $[5] = handleClick;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setOpen(false);
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== user?.phones) {
    t5 = user?.phones?.map(_temp) || [];
    $[8] = user?.phones;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== isAuthenticated || $[11] !== open || $[12] !== t5) {
    t6 = <CallbackRequestModal open={open} onClose={t4} isAuthenticated={isAuthenticated} userPhoneNumbers={t5} />;
    $[10] = isAuthenticated;
    $[11] = open;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t3 || $[15] !== t6) {
    t7 = <>{t3}{t6}</>;
    $[14] = t3;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}
function _temp(p) {
  return p.number;
}